import React from 'react'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import useDocTitle from '../helpers/hooks/useDocTitle'
import ProviderDashboard from '../components/marketplace/provider/ProviderDashboard'
import ProviderServiceForm from '../components/marketplace/provider/services/ProviderServiceForm'
import ProviderProfile from '../components/marketplace/provider/ProviderProfile'
import ServiceRequestsList from '../components/marketplace/requests/ServiceRequestsList'
import ServiceRequestConversation from '../components/marketplace/requests/ServiceRequestConversation'

const ProviderRequests = () => <ServiceRequestsList side="provider" basePath="/provider/requests" />

const ProviderConversation = () => <ServiceRequestConversation side="provider" listPath="/provider/requests" />

const ProviderRoutes = ({ match: { url } }) => {
  document.title = useDocTitle()

  return (
    <Switch>
      <Route path={`${url}`} exact component={ProviderDashboard} />
      <Route path={`${url}/services/create`} exact component={ProviderServiceForm} />
      <Route path={`${url}/services/:id(\\d+)/edit`} exact component={ProviderServiceForm} />
      <Route path={`${url}/profile`} exact component={ProviderProfile} />
      <Route path={`${url}/requests`} exact component={ProviderRequests} />
      <Route path={`${url}/requests/:id(\\d+)`} exact component={ProviderConversation} />
      <Redirect to={url} />
    </Switch>
  )
}

export default withRouter(ProviderRoutes)
